import type { Observable as ObservableType } from 'rxjs/Observable';
import fetchJson$ from '@atlassian/jira-fetch/src/utils/as-json-stream.tsx';
import type { VersionResponse } from '../../model/version/version-types.tsx';
import { getVersionUrl } from '../software/software-api-urls.tsx';

export const fetchVersionDataRest = (boardId: string): ObservableType<VersionResponse> =>
	fetchJson$(getVersionUrl(boardId));
